import { getCookie, setCookie } from "@/utils.js";
import { EComLanguage } from "@/enums/commonEnums.js";

export const uiTutorial = {
   data() {
      return {
         videos: {},
         showDebugger: false,
         debuggerHandler: null,
      };
   },
   mounted() {
      this.handlerDebugger();
   },
   beforeDestroy() {
      if (this.debugger) {
         document.body.removeEventListener("keydown", this.debuggerHandler);
      }
   },

   methods: {
      handlerDebugger() {
         this.debuggerHandler = (event) => {
            let held = false;

            if (event.ctrlKey && event.altKey) {
               held = true;
            }

            if (held && event.keyCode == 68) {
               this.showDebugger = !this.showDebugger;
            }
         };

         document.body.addEventListener("keydown", this.debuggerHandler);
      },
      getLanguageSuffix(currentLanguage) {
         switch (currentLanguage) {
            case 1:
               return "tr";
            case 2:
               return "en";
            case 3:
               return "de";
            case 4:
               return "ru";
            default:
               return "en";
         }
      },
      openVideoModal(tutorialUuid) {
         this.$nextTick(() => {
            setTimeout(() => {
               if (this.$refs.uiModal && this.$refs.uiModal.length > 0) {
                  const hasOpenModal = this.$refs.uiModal.some((modal) => modal.isModalOpen);
                  if (hasOpenModal) return;

                  this.$refs.uiModal.forEach((modal) => {
                     if (modal.video && modal.video.uuid === tutorialUuid && !modal.video.isWatched) {
                        modal.isModalOpen = true;
                     }
                  });
               }
            }, 2000);
         });
      },
      handlerCookieController(currentRoute) {
         const tutorials = this.$store.state.ui.tutorials;
         if (tutorials.length === 0) return;

         const currentLanguage = this.$store.state.user.user.language;
         const languageSuffix = this.getLanguageSuffix(currentLanguage);

         const relevantTutorials = tutorials.filter((tutorial) => tutorial.relatedUris.includes(currentRoute) && Object.prototype.hasOwnProperty.call(tutorial.title, EComLanguage[currentLanguage]));

         if (relevantTutorials.length === 0) return;

         relevantTutorials.forEach((tutorial) => {
            const cookieCheck = getCookie(`watched_${tutorial.uuid}_${languageSuffix}`);

            this.$set(this.videos, tutorial.uuid, {
               relatedPage: tutorial.relatedUris,
               title: tutorial.title[EComLanguage[currentLanguage]],
               description: tutorial.description[EComLanguage[currentLanguage]],
               isWatched: cookieCheck === "true",
               uuid: tutorial.uuid,
               lang: languageSuffix,
               videoUrl: `${process.env.VUE_APP_CDN_URL}/video/${tutorial.uuid}_${languageSuffix}.mp4`,
            });

            if (!cookieCheck) {
               this.openVideoModal(tutorial.uuid);
            }
         });
      },
      onModalClose(uuid, langSuffix) {
         setCookie(`watched_${uuid}_${langSuffix}`, "true", 365);
         if (this.$refs.uiModal && this.$refs.uiModal.length > 0) {
            this.$refs.uiModal.forEach((modal) => {
               if (modal.video && modal.video.uuid === uuid) {
                  modal.isModalOpen = false;
               }
            });
         }
      },
   },
   watch: {
      $route: {
         handler: function (route) {
            this.handlerCookieController(route.name);
         },
         deep: true,
      },
   },
};
